"use client";

import { useEffect } from "react";

const SERVICE_WORKER_PATH = "/sw.js";
const SERVICE_WORKER_SCOPE = "/";

export function ServiceWorkerRegister() {
    useEffect(() => {
        if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
            return;
        }

        // In dev the SW would serve stale chunks after rebuilds or dependency upgrades; remove any leftover registration and caches
        if (process.env.NODE_ENV !== "production") {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                registrations.forEach((registration) => {
                    registration.unregister();
                });
            });
            if ("caches" in window) {
                caches.keys().then((keys) => {
                    keys.filter((key) => key.startsWith("scamatrix-cache")).forEach((key) => {
                        caches.delete(key);
                    });
                });
            }
            return;
        }

        const handleBeforeInstallPrompt = (event: Event) => {
            event.preventDefault();
        };

        const handleAppInstalled = () => {
            console.info("ScaMatrix PWA installed");
        };

        const registerServiceWorker = async () => {
            try {
                const registration = await navigator.serviceWorker.register(SERVICE_WORKER_PATH, {
                    scope: SERVICE_WORKER_SCOPE,
                });

                if (registration.waiting) {
                    registration.waiting.postMessage({ type: "SKIP_WAITING" });
                }

                navigator.serviceWorker.addEventListener("controllerchange", () => {
                    console.info("App updated - reload to use the latest offline experience");
                });
            } catch (error) {
                console.error("Service worker registration failed", error);
            }
        };

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        window.addEventListener("appinstalled", handleAppInstalled);

        registerServiceWorker();

        return () => {
            window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
            window.removeEventListener("appinstalled", handleAppInstalled);
        };
    }, []);

    return null;
}
